import {
  ContentServiceHttpClient,
  ContentServiceBaseQuery,
} from '../../common/services/httpClient';

const baseServicePath = (projectId, contentThreadId) =>
  `projects/${projectId}/workflow/${contentThreadId || ''}`;

export const getWorkflowStatus = async (projectId, contentThreadId) => {
  const response = await ContentServiceHttpClient.get(
    baseServicePath(projectId, contentThreadId)
  );
  return response.data;
};

export const updateWorkflowStatus = async (
  projectId,
  contentThreadId,
  workflowAction
) => {
  return ContentServiceHttpClient.post(
    `${baseServicePath(projectId, contentThreadId)}/${workflowAction}`
  );
};

export const getAnalysisWorkflowStatus = async (projectId, contentThreadId) => {
  const response = await ContentServiceHttpClient.get(
    `projects/${projectId}/workflow/${contentThreadId}`
  );
  return response.data;
};

export const workflowApiEndpoints = {
  endpoints: (build) => ({
    getWorkflowStatus: build.query({
      baseQuery: ContentServiceBaseQuery,
      query: ({ projectId, contentThreadId }) => ({
        url: `/projects/${projectId}/workflow/${contentThreadId}`,
        method: 'GET',
      }),
      providesTags: ['ContentWorkflow'],
    }),
    updateWorkflowStatus: build.mutation({
      baseQuery: ContentServiceBaseQuery,
      query: ({ projectId, contentId, step }) => ({
        url: `projects/${projectId}/workflow/${contentId}/${step}`,
        method: 'POST',
      }),
      invalidatesTags: ['ContentItem', 'ContentVersions', 'ContentWorkflow'],
    }),
  }),
};
